import { useQuery } from "@apollo/client/react";
import waitForQueries from "components/waitForQueries";
import { GetAllCompanies } from "hooks/apollo/company/company.gql";
import CompanyIndexView from "./CompanyIndexView";

export default function CompanyIndexContainer() {
  const queries = [useQuery(GetAllCompanies)];

  return waitForQueries({ queries })(CompanyIndexView)();
}
